import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

export const socket = io(SOCKET_URL, {
  autoConnect: false,
  withCredentials: true
});

export const connectSocket = () => {
  if (!socket.connected) {
    socket.connect();
  }
};

export const clearSocketBuffer = () => {
  if (Array.isArray(socket.sendBuffer)) {
    socket.sendBuffer = [];
  }
};

export const disconnectSocket = () => {
  clearSocketBuffer();
  socket.disconnect();
  clearSocketBuffer();
};
